export function dataGridNestedColumnGetter(_, row, col) {
  const fields = col.field.split(".");
  let val = row;
  for (let field of fields) {
    val = val?.[field];
  }
  return val;
}
